import { useMemo } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

function CleaningHistoryTable({ selectedDevice, cleaningHistoryData }) {
  const tableData = useMemo(() => {
    const columns = [
      { Header: "Last Measurement", accessor: "lastMeasurement" },
      { Header: "Last Clean", accessor: "lastClean" },
      { Header: "Type", accessor: "type" },
      { Header: "Cycles", accessor: "cycles" },
    ];

    const rows =
      cleaningHistoryData?.map((record) => ({
        lastMeasurement: `${record.lastMeasDate} ${record.lastMeasTime}`,
        lastClean: `${record.lastCleanDate} ${record.lastCleanTime}`,
        type: record.Type,
        cycles: record.Cycles || 0,
      })) || [];

    return { columns, rows };
  }, [cleaningHistoryData, selectedDevice]);

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Cleaning History for Device {selectedDevice}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={tableData}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
}

CleaningHistoryTable.propTypes = {
  selectedDevice: PropTypes.string.isRequired,
  cleaningHistoryData: PropTypes.arrayOf(PropTypes.object),
};

export default CleaningHistoryTable;
